<template>
  <div>
    <Banner :status="status" @setVisible="setVisible" />
    <Target />
    <Highlights />
    <JoinNow :status="status" @setVisible="setVisible" />
    <Qs :status="status" @setVisible="setVisible" />
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
    >
      <Join v-if="dialogVisible" :row="row" @cancel="dialogVisible = false"></Join>
    </el-dialog>
    <el-dialog
      title="申请记录"
      :visible.sync="dialogVisible2"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="1000px"
    >
      <ApplyRecords
        v-if="dialogVisible2"
        @cancel="dialogVisible2 = false"
        @confirm="confirm"
      ></ApplyRecords>
    </el-dialog>
  </div>
</template>

<script>
import Banner from './components/banner.vue'
import Target from './components/target.vue'
import Highlights from './components/highlights.vue'
import JoinNow from './components/joinNow.vue'
import Qs from './components/qs.vue'
import Join from './components/join.vue'
import ApplyRecords from './components/applyRecords.vue'
import { getAccessToken } from '@/utils/userInfo'

export default {
  components: {
    Banner,
    Target,
    Highlights,
    JoinNow,
    Qs,
    Join,
    ApplyRecords
  },
  data () {
    return {
      dialogVisible: false,
      dialogVisible2: false, // 申请记录
      status: {
        showTest: true
      },
      row: {}
    }
  },
  created () {
    this.getApplyStatus()
  },
  methods: {
    setVisible () {
      if (this.status.showTest) {
        this.dialogVisible = true
        return
      }
      if (this.status.showApplyRecords) {
        this.dialogVisible2 = true
        return
      }
      this.$router.push({
        name: 'ecologicalServices'
      })
    },
    getApplyStatus () {
      if (!getAccessToken()) {
        return
      }
      this.$http
        .get('/front/oms/sso/supplier/applyStatus')
        .then(({ data: res }) => {
          console.log(res)
          if (res.code === 0) {
            this.status = res.data
          }
        })
    },
    confirm (obj) {
      this.dialogVisible2 = false
      this.row = obj
      this.dialogVisible = true
    }
  }
}
</script>

<style lang="scss" scoped></style>
